import React from "react";
import wallet from "../../images/blockchain/empty-wallet-add.svg";
import users from "../../images/blockchain/ai-users.svg";
import network from "../../images/blockchain/status-up.svg";
import sheild from "../../images/blockchain/strongbox-2.svg";
const WalletSection = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-8">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className=" text-white text-center opacity-75">
                  How to Calculate the Value of Your TopCoin UK Rewards
                </h1>
                <p className="text-white text-center opacity-50">
                  TopCoin UK operates with five wallets, each unlocking at
                  different reward levels. As you accumulate more TopCoin UK,
                  new wallets become available, increasing your rewards.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div><div className="text-center py-3"> <h4>Step-by-Step Calculation</h4></div></div>
        <div className="row justify-content-center">
              
          <div className="col-lg-6">
        
           
            <div className="card bg-white mb-3">
              <div className="card-body">
                <h5  className="text-dark-emphasis">1. Determine the Value of Each TopCoin</h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>Each TopCoin UK Cash Wallet contains a set amount of money.</li>
                  <li>
                    To find the TopCoin value, divide the total amount in the
                    wallet by the total number of TopCoin in the company.
                  </li>
                </ul>
              </div>
            </div>
            <div className="card bg-white">
              <div className="card-body">
                <h5 className="text-dark-emphasis">2. Calculate Your Total Rewards</h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {" "}
                    Once you have the TopCoin value, multiply it by the number of
                    TopCoin you own.
                  </li>
                  <li>Repeat this process for each unlocked wallet.</li>
                  <li>
                    Add up the values from all your wallets to determine your
                    total TopCoin UK rewards.
                  </li>
                  <li>
                    {" "}
                    To find the TopCoin value, divide the total amount in the
                    wallet by the total number of TopCoin in the company.
                  </li>
                </ul>
              </div>
            </div>
          </div>
            <div className="col-lg-6">
          
           
            <div className="card bg-white mb-3">
              <div className="card-body">
                <h5  className="text-dark-emphasis">Example Calculation</h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>Wallet Balance: £1,000</li>
                  <li>Total TopCoin in the Company: 5,000</li>
                  <li>TopCoin Value: £1,000 ÷ 5,000 = £0.20 (20p per unit)</li>
                </ul>
              </div>
            </div>
            <div className="card bg-white">
              <div className="card-body">               
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {" "}
                   If you have 300 TopCoin, your rewards from this wallet would be: 300 x £0.20 = £60
                  </li>
                  <li>Repeat this process for each unlocked wallet, then sum all wallet values to find your total TopCoin UK rewards.</li>
                  <li>Note: TopCoin UK is a reward system, not an investment. The value of your rewards depends on the total number of TopCoin and wallet balances at any given time.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div className="col-lg-8">
            <p className="text-center">The role of TopCoin is as follows: when you reach each milestone, the corresponding unit in your wallet is unlocked. If you choose to cash in before reaching the next milestone, your payout will be calculated based on the TopCoin up to the last milestone you unlocked, including any TopCoin from the milestones you have purchased until then.</p>
          </div>
        </div>
          <div className="container">
        <div className="row">
          <div className="col-lg-3">
            <div className="card bg-white min-h150">
              <div className="card-body  p-4">
                <div className="d-flex gap-3 align-items-center">
                  <div className="icon-img">
                    <img src={wallet} width={24} alt="" />
                  </div>
                  <div className="text-dark opacity-75">
                    Each TopCoin UK Cash Wallet contains a set amount of money.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="card bg-white min-h150">
              <div className="card-body p-4">
                <div className="d-flex gap-3 align-items-center">
                  <div className="icon-img">
                    <img src={users} width={24} alt="" />
                  </div>
                  <div className="text-dark opacity-75">Every TopCoin is recorded and traceable</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="card bg-white min-h150">
              <div className="card-body p-4">
                <div className="d-flex gap-3 justify-content-center align-items-center">
                  <div className="icon-img">
                    <img src={sheild} width={24} alt="" />
                  </div>
                  <div className="text-dark opacity-75">
                    No one can lose value or be skipped, the blockchain
                    protects your progress
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="card bg-white min-h150">
              <div className="card-body p-4">
                <div className="d-flex gap-3 align-items-center">
                  <div className="icon-img">
                    <img src={network} width={24} alt="" />
                  </div>
                  <div className="text-dark opacity-75">
                    Each business creates its own chain under the TopCoin UK
                    network
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default WalletSection;
